module.exports = __webpack_public_path__ + "static/media/banner-background.462279bc.png";